const CategoryDetailData = [
  {
    bgcolor: "#FA5738",
  },
  {
    bgcolor: "#DDB967",
  },
  {
    bgcolor: "#51344D",
  },
  {
    bgcolor: "#DDB967",
  },
  {
    bgcolor: "#6CFA38",
  },
  {
    bgcolor: "#67C2DD",
  },
  {
    bgcolor: "#C267D3",
  },
  {
    bgcolor: "#67CFDD",
  },
];
export default CategoryDetailData;
